import { Component, OnInit } from '@angular/core';
import { PlansService } from '../services/plans.service';
import { OrderService } from '../services/order.service';
import { SnackBarService } from '../services/snack-bar.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css'],
})
export class PricingComponent implements OnInit {
  public couponCode: any;
  public popUpMode = false;
  public plans = [];
  public paymentMode = 'سالانه';
  public monthlyPay = 25;
  public totalPaymentWithoutDiscount = 300;
  public totalPaymentWithDiscount = 300;
  public discountAlert = 'null';
  public discountCode: any;
  public discountAmount = 10;
  public orderSpinner = false;
  public activeMode = 'tab1';
  public zarinPalUrl: any;
  public activePlan: any;
  public helper: any;
  public userIsLoggedIn;
  public selectedOrder = {
    plan_id: '',
    coupon_code: '',
  };
  public discountMessage;
  public selectedPlan;
  public error;
  public errorMessage;
  constructor(
    private plansService: PlansService,
    private orderService: OrderService,
    private snackbarService: SnackBarService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.checkLocalVar();
    this.getListOfPlans();
    this.checkLogin();
  }
  checkLogin(): any {
    const token = localStorage.getItem('token');
    if (token !== null) {
      this.userIsLoggedIn = true;
    } else {
      this.userIsLoggedIn = false;
    }
  }
  pay(): any {
    this.popUpMode = true;
    if (this.paymentMode === 'سالانه') {
      this.plansService.getYearlyPlan().subscribe((res) => {
        this.selectedPlan = res.data;
        this.totalPaymentWithoutDiscount = res.data.price
          .toString()
          .substr(0, 3);
      });
    } else if (this.paymentMode === 'ماهانه') {
      this.plansService.getMonthlyPlan().subscribe((res) => {
        this.selectedPlan = res.data;
        this.totalPaymentWithoutDiscount = res.data.price
          .toString()
          .substr(0, 2);
      });
    }
  }
  cancelPay(): any {
    this.popUpMode = false;
    this.discountAlert = 'null';
    this.discountCode = '';
  }
  switchToMonthlyMode(): any {
    this.paymentMode = 'ماهانه';
    this.monthlyPay = 50;
    this.totalPaymentWithDiscount = 50;
  }
  switchToYearlyMode(): any {
    this.paymentMode = 'سالانه';
    this.monthlyPay = 25;
    this.totalPaymentWithDiscount = 300;
  }
  verifyDiscountCode(): any {
    this.selectedOrder = {
      plan_id: this.selectedPlan.id,
      coupon_code: this.couponCode,
    };
    this.orderService.verifyDiscount(this.selectedOrder).subscribe(
      (data) => {
        this.discountAlert = 'success';
        this.totalPaymentWithDiscount = data.total;
        const discountAmount = String(data.discount / 1000);
        this.discountMessage =
          'تخفیف ' + discountAmount.substr(1) + ' هزار تومانی اعمال شد';
      },
      (err) => {
        this.discountAlert = 'fail';
        this.errorMessage = err.error.coupon_code[0];
      }
    );
    // if (this.discountCode === 'pari'){
    //   this.discountAlert = 'success';
    //   this.totalPaymentWithDiscount = this.totalPaymentWithoutDiscount - this.discountAmount;
    // } else if (this.discountCode !== 'hello'){
    //   this.discountAlert = 'fail';
    //   this.totalPaymentWithDiscount = this.totalPaymentWithoutDiscount;
    // }
  }
  getListOfPlans(): any {
    this.plansService.getPlansList().subscribe((res) => {
      this.plans = res.data;
    });
  }
  buyPlan(): any {
    this.selectedOrder = {
      plan_id: this.selectedPlan.id,
      coupon_code: this.couponCode,
    };
    if (this.selectedOrder.coupon_code === undefined) {
      const orderSelected = {
        plan_id: this.selectedPlan.id,
      };
      this.orderPlan(orderSelected);
    } else {
      this.orderPlan(this.selectedOrder);
    }
  }
  orderPlan(selectedPlan): any {
    this.orderSpinner = true;
    this.snackbarService.showSnackBar(
      'لطفا تا انتقال به صفحه پرداخت صبر کنید.',
      'green-snackbar'
    );
    this.orderService.storePlan(selectedPlan).subscribe(
      (data) => {
        if (data.action) {
          this.zarinPalUrl = data.action;
          localStorage.setItem('paymentMode', 'action');
          window.location.href = this.zarinPalUrl;
          this.orderSpinner = false;
        } else {
          localStorage.setItem('paymentMode', 'driver');
          setTimeout(() => {
            this.router.navigateByUrl('/payment').then();
          }, 1000);
        }
      },
      (error) => {
        this.snackbarService.showSnackBar(error.message, 'red-snackbar');
      }
    );
  }
  navigateToLoginPage(): any {
    localStorage.setItem('WhichPageComeFrom', 'payment');
    this.router.navigateByUrl('/login').then();
  }
  checkLocalVar(): any {
    setTimeout(() => {
      if (localStorage.getItem('WhichPageComeFrom') === 'payment') {
        localStorage.removeItem('WhichPageComeFrom');
      }
    }, 2000);
  }
  startFree(): any {
    if (this.userIsLoggedIn) {
      this.router.navigateByUrl('/').then();
    } else {
      this.router.navigateByUrl('/register').then();
    }
  }
}
